import axios from 'axios'
import { PhoneNumberType } from '../enums/enums'
import { ExtensionProspectData } from '../types'

const PossibleNamesReg = /[A-Z][a-zA-Z]+( [A-Z]([a-zA-Z])+)?/g
const mobileExtReg = /(\bmobile\b|\(m\)|\bm\b|\bcell\b|\(c\)|\bc\b)/g
const emailReg = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi
const telephoneReg = /((?:\+|\(|\d)|(?:\+|\(|\d))[\d\-/(). ]{5,}\d/gi
const streetReg = /\b(Avenue|Ave|Center|Court|Ct|Street|St|Drive|Lane|Ln|Road|Rd|Blvd|Plaza|Parkway|Pkwy)(\.|\s|,|\b)/g
const jobsReg =
  /\b(Director|Sales|Marketing|Manager|Finance|HR|Engineering|Engineer|Specialist|Software|Frontend|Backend|Developer|IT|CEO|COO|CIO|CMO|VP|V.P.|Vice President|President|Chief|Associate|Assistant|Attorney|Analyst|Senior|Account|Payable|Receivable|GM|marketing|marketer|brand|inbound|online|internet|digital|search engine|organic|SEO|content|social media|Media Strategist|paid media|ppc|user acquisition|SEM|email|crm|growth|Sr.|development|business)\b/gi
const regCityStateZip = /[A-Z]{1}[A-Za-z]{1,35}[, ]{1,}[A-Z]{1}[A-Za-z]{1,35}[, ]{1,3}\d{5,}/g

//search countries names
const searchCountries = async (possibleNamesArray: string[]) => {
  const result: { possibleName?: string; commonName?: string } = {}
  for (const possibleName of possibleNamesArray) {
    try {
      const res = await axios.get(`https://restcountries.com/v3.1/name/${possibleName}`)
      const data = await res.data
      if (data.length > 0) {
        const foundedCountry = data.at(0).name
        if (
          foundedCountry.common.split(' ').includes(possibleName) ||
          foundedCountry.official.split(' ').includes(possibleName)
        ) {
          result.commonName = foundedCountry.common
          result.possibleName = possibleName
          return result
        }
      }
    } catch (e) {
      console.log('failed to search countries', e)
    }
  }
  return result
}
//search companies names
const searchCompanies = async (possibleNamesArray: string[]) => {
  const result: Partial<ExtensionProspectData> = {
    email: '',
    fullName: '',
    firstName: '',
    lastName: '',
    phoneItems: [],
    address: '',
    zipcode: '',
  }
  for (const possibleName of possibleNamesArray) {
    try {
      const res = await axios.get(`https://autocomplete.clearbit.com/v1/companies/suggest?query=${possibleName}`)
      const data = res.data
      if (data.length > 0) {
        const foundedCompany = data.find((item: { name: string; domain: string }) => item.name === possibleName)
        if (foundedCompany) {
          result.company = foundedCompany.name
          return result
        } else {
          //check if there is no already first name and last name
          if (!result.firstName) {
            const firstAndLastNames = possibleName.split(' ')
            result.firstName = firstAndLastNames.at(0)
            result.lastName = firstAndLastNames.at(1)
          }
        }
      } else {
        //check if there is no already first name and last name
        if (!result.firstName) {
          const firstAndLastNames = possibleName.split(' ')
          result.firstName = firstAndLastNames.at(0)
          result.lastName = firstAndLastNames.at(1)
        }
      }
    } catch (e) {
      console.log('companies search fail', e)
    }
  }
  return result
}

export const evaluateText = async (text: string): Promise<any> => {
  const data: ExtensionProspectData = {}

  text = text.trim()

  data.email = text.match(emailReg)?.at(0)
  text = text.replaceAll(emailReg, '').replace(/\s+/g, ' ').trim()

  data.jobTitle = text.match(jobsReg)?.join(' ')
  text = text.replaceAll(jobsReg, '').replace(/\s+/g, ' ').trim()

  data.phoneItems = text.match(telephoneReg)?.map((number) => ({ number, type: '' })) ?? []

  //to check if there is mobile number
  const isMobileIndex = text.search(mobileExtReg)
  if (isMobileIndex > -1 && data.phoneItems.length) {
    const slicedText = text.slice(isMobileIndex)
    const mobilePhone = slicedText.match(telephoneReg)?.at(0)
    data.phoneItems = data.phoneItems.map((item) =>
      item.number === mobilePhone ? { number: item.number, type: PhoneNumberType.mobile } : item
    )
  }
  text = text.replaceAll(telephoneReg, '').replace(/\s+/g, ' ').trim()

  data.zipcode = text.match(regCityStateZip)?.at(0)

  const isStreetIndex = text.search(streetReg)
  if (isStreetIndex > -1) {
    const beforeStreet = text.slice(0, isStreetIndex).split(' ').at(-1)
    const afterStreet = text.slice(isStreetIndex).split(' ').at(1)
    data.address = `${text.at(isStreetIndex) ?? ''} ${beforeStreet ?? ''} ${afterStreet ?? ''}`.trim()
  }

  //get all possible Names
  const possibleNames = text.match(PossibleNamesReg)
  if (possibleNames && possibleNames.length) {
    const countriesRes = await searchCountries(possibleNames)
    data.address = (data?.address ?? '') + (countriesRes?.commonName ?? '')

    const res = await searchCompanies(possibleNames)
    data.firstName = res.firstName
    data.lastName = res.lastName
    data.company = res.company
  }

  return data
}
